// extracted by mini-css-extract-plugin
module.exports = {"Share":"share_Share__kv9Ud"};